import React from 'react';
import { Navbar, Col } from 'reactstrap';
import { Link } from 'react-router-dom';

import logo from 'assets/img/brand/logo.svg';
import { Intl } from 'components';

const AuthNavbar = React.memo( ( { pathname } ) => (
  <Navbar className="navbar-top auth-navbar navbar-expand navbar-horizontal bg-white">
    <div className="d-flex flex-wrap align-items-end w-100">
      <Col md>
        <a href="/">
          <img alt="Massphoning" src={logo} width="226" />
        </a>
      </Col>
      {pathname !== '/auth/login'
      && pathname !== '/auth/select-app'
      && !pathname.includes( '/auth/recover-password/' )
      && (
      <Col md="auto" className="pr-0">
        <Link to="/auth/login">
          <h2 className="text-gray-7 m-0">
            <Intl id="login" />
          </h2>
        </Link>
      </Col>
      )}
    </div>
  </Navbar>
) );

export default AuthNavbar;
